module.exports = __webpack_public_path__ + "img/190.9c027f85.jpg";